import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { usersSliceSelector } from "../../../redux/features/usersSlice";

export default function CRMRoute() {
  const { user, authState } = useSelector((state) => usersSliceSelector(state));
  const isSuperAdmin = user?.superAdmin === true;

  // Wait for auth to initialize
  if (authState === null || authState === "pending") {
    return null; // or a loading spinner
  }

  // Redirect if not authenticated or not super admin
  if (authState !== "in" || !isSuperAdmin) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
